import { createAction } from 'redux-act';
import { Options } from './localeReducer';

const ACTION_PREFIX = '@@localize/';
const INITIALIZE = `${ACTION_PREFIX}INITIALIZE`;
const SET_ACTIVE_LANGUAGE = `${ACTION_PREFIX}SET_ACTIVE_LANGUAGE`;
const ADD_TRANSLATION_FOR_LANGUAGE = `${ACTION_PREFIX}ADD_TRANSLATION_FOR_LANGUAGE`;

export const initialize = createAction<{ languages: string[]; options?: Options }>(INITIALIZE);

export const addTranslationForLanguage = createAction<{
  translation: { [key: string]: string };
  language: string;
}>(ADD_TRANSLATION_FOR_LANGUAGE);

export const setActiveLanguage = createAction<string>(SET_ACTIVE_LANGUAGE);
